import React, { Component } from 'react'

export class ConnectionVisualize extends Component {
    render() {
        return (
            <div>
                
            </div>
        )
    }
}
